import React from "react";
import { useLocation } from "react-router-dom";
import "./Hero.css";
import HeroImage from "./assets/hero-image.png";

function Hero() {
  const location = useLocation();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const headerOffset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition =
      elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  };

  const handleScroll = (e, id) => {
    e.preventDefault();

    // Wenn wir NICHT auf der Startseite sind
    if (location.pathname !== "/") {
      window.location.href = "/";

      setTimeout(() => scrollToSection(id), 200);
      return;
    }

    // Wenn wir auf der Startseite sind
    scrollToSection(id);
  };

  return (
    <section className="Hero" id="home">
      <div className="Hero-content">
        <div className="Hero-text">
          <h1>
            Ingenieurbüro<br />Stein & Wagner
          </h1>
          <p>Zertifizierte Energieberatung in Koblenz und Umgebung</p>

          <a
            href="#contact"
            className="hero-btn"
            onClick={(e) => handleScroll(e, "contact")}
          >
            Jetzt Termin vereinbaren!
          </a>
        </div>

        <div className="Hero-image">
          <img src={HeroImage} alt="Ingenieurbüro" />
        </div>
      </div>
    </section>
  );
}

export default Hero;
